import React, { memo } from 'react'

import { Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'

import { resolveSoftwareIcon } from './iconRegistry'

function SoftwareIcon({ iconName, size = iconSizeMedium, className = '' }) {
  const SvgComponent = resolveSoftwareIcon(iconName)
  if (!SvgComponent) return null

  return (
    <Icon
      svgComponent={SvgComponent}
      size={size}
      className={className}
      notSpaced
    />
  )
}

SoftwareIcon.propTypes = {
  iconName: string.isRequired,
  size: shape({ width: string, height: string }),
  className: string,
}

export default memo(SoftwareIcon)
